/* Copyright (c) 2020-present CloudIO Inc */

import React, { useEffect } from 'react';
import { OnInitCallback } from 'init/types';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';
import { intro } from 'utils/intro';
import Main from './routes/Main';

const touchSupported =
  'ontouchstart' in window ||
  (window.DocumentTouch && document instanceof window.DocumentTouch);

export default function IndexApp({
  onInit,
}: {
  onInit: OnInitCallback;
}): React.ReactElement {
  useEffect(() => {
    intro();
  }, []);

  return (
    <DndProvider backend={touchSupported ? TouchBackend : HTML5Backend}>
      <Main onInit={onInit} />
    </DndProvider>
  );
}
